import { useNavigate } from "@tanstack/react-router";

import { trpc } from "@blis/trpc/react";

import { LoadingPage } from "@/components/LoadingPage";
import { Breadcrumb } from "@/components/ui/breadcrumbs";
import { Tab, TabPanel, Tabs, TabsList } from "@/components/ui/tabs";
import { toast } from "@/components/ui/toast";
import { AuthProviderForm } from "../components/auth/AuthProviderForm";
import { DeleteAuthProviderButton } from "../components/auth/DeleteAuthProviderButton";
import { Mappers } from "../components/auth/Mappers";
import { Section } from "../components/Section";
import { TabLayout } from "../components/TabLayout";
import { useTabSearch } from "../hooks";

export function EditProviderPage(params: { id: number }) {
  const navigate = useNavigate();
  const tabsProps = useTabSearch("config");

  const { data, isLoading } = trpc.admin.auth.get.useQuery(params);

  const update = trpc.admin.auth.update.useMutation({
    onSuccess() {
      navigate({ to: "/admin/auth" });
      toast.success("Auth provider updated successfully");
    },
    onError(err) {
      toast.error("Error updating auth provider", {
        description: err.message,
      });
    },
  });

  const existing = data;

  return (
    <>
      <Section.Title
        breadcrumb={
          <>
            <Breadcrumb href={{ to: "/admin/auth" }}>Authentication</Breadcrumb>
            <Breadcrumb>{data?.name}</Breadcrumb>
          </>
        }
        actions={<DeleteAuthProviderButton id={Number(params.id)} />}
      >
        {data?.name}
      </Section.Title>
      {isLoading || !existing ? (
        <LoadingPage />
      ) : (
        <Tabs {...tabsProps}>
          <TabsList className="w-full justify-start">
            <Tab id="config">Configuration</Tab>
            <Tab id="mappers">Mappers</Tab>
          </TabsList>
          <TabPanel id="config">
            <TabLayout>
              <AuthProviderForm
                provider={existing}
                onSubmit={async (values) => {
                  const { id, ...input } = values;
                  await update.mutateAsync({ id, ...input });
                }}
              />
            </TabLayout>
          </TabPanel>
          <TabPanel id="mappers">
            <Mappers provider={existing} />
          </TabPanel>
        </Tabs>
      )}
    </>
  );
}
